import React, { useContext, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import IntlMessages from '../../../utils/IntlMessages';
import Grid from '@material-ui/core/Grid';
import GridContainer from '../../../../@jumbo/components/GridContainer';

import { useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import { Box, fade } from '@material-ui/core';
import { AuhMethods } from '../../../../services/auth';
import ContentLoader from '../../ContentLoader';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CmtImage from '../../../../@coremat/CmtImage';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { CurrentAuthMethod } from '../../../constants/AppConstants';
import { NavLink } from 'react-router-dom';
import AuthWrapper from './AuthWrapper';
import { THEME_TYPES } from '../../../constants/ThemeOptions';
import AppContext from '../../contextProvider/AppContextProvider/AppContext';

const useStyles = makeStyles(theme => ({
  authThumb: {
    backgroundColor: fade(theme.palette.primary.main, 0.12),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '50%',
      order: 2,
    },
  },
  authContent: {
    padding: 30,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: props => (props.variant === 'default' ? '50%' : '100%'),
      order: 1,
    },
    [theme.breakpoints.up('xl')]: {
      padding: 50,
    },
  },
  titleRoot: {
    marginBottom: 14,
    color: theme.palette.text.primary,
  },
  textFieldRoot: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: fade(theme.palette.common.dark, 0.12),
    },
  },
  formcontrolLabelRoot: {
    '& .MuiFormControlLabel-label': {
      [theme.breakpoints.down('xs')]: {
        fontSize: 12,
      },
    },
  },
}));
//variant = 'default', 'standard'
const SignIn = ({ method = CurrentAuthMethod, variant = 'default', wrapperVariant = 'default' }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [hotelCode, setHotelCode] = useState('');
  const [demoCode, setDemoCode] = useState('DEMO');
  const [demoEmail, setDemoEmail] = useState('DEMO');
  const [demoPassword, setDemoPassword] = useState('DEMO');
  const dispatch = useDispatch();
  const classes = useStyles({ variant });

  const date = new Date();
  if (variant == 'milenij') {
    //   setThemeType(THEME_TYPES.DARK);
  }
  var logoImage = '/images/webbookingpro_logo.png';
  var hostName = window.location.hostname;
  var brandId = 0;

  if (hostName === 'app.mikos.io' || hostName === 'app.forotel.io') brandId = 1;
  if (brandId == 0) document.title = 'WebBookingPro';
  if (brandId == 1) document.title = 'forotel';

  const onSubmit = () => {
    if (variant === 'standard' && email != '' && password != '')
      dispatch(AuhMethods[method].onLogin({ email, password, hotelCode }));
    if (variant === 'milenij' && email != '' && password != '' && hotelCode != '')
      dispatch(AuhMethods[method].onLogin({ email, password, hotelCode }));
  };

  const onSubmit2 = () => {
    if (variant === 'milenij') dispatch(AuhMethods[method].onLogin({ demoEmail, demoPassword, demoCode }));
  };

  return (
    <AuthWrapper variant={wrapperVariant}>
      {variant === 'default' ? (
        <Box className={classes.authThumb}>
          <CmtImage src={'/images/webbookingpro_logo.png'} />
        </Box>
      ) : null}
      <Box className={classes.authContent}>
        <Box mb={7}>
          <GridContainer>
            <Grid
              container
              xs={12}
              sm={12}
              xl={12}
              direction="row"
              alignContent="center"
              alignItems="center"
              justify="center">
              {variant === 'standard' && brandId == 0 && (
                <img src={variant === 'standard' ? logoImage : '/images/logo-milenij.png'} style={{ maxHeight: '96px' }} />
              )}
              {variant === 'standard' && brandId == 1 && (
                <>
                  <img
                    src="https://cdn.webbookingpro.com/forotel/sophiasurge_logo.png"
                    style={{ paddingRight: '20px', maxWidth: '25%', maxHeight: '96px' }}
                  />
                  <img
                    src="https://cdn.webbookingpro.com/forotel/lunalink_logo.png"
                    style={{ paddingRight: '20px', maxWidth: '25%', maxHeight: '96px' }}
                  />
                  <img
                    src="https://cdn.webbookingpro.com/forotel/zoezoom_logo.png"
                    style={{ maxWidth: '25%', maxHeight: '96px' }}
                  />
                </>
              )}
              {variant !== 'standard' && <img src="/images/logo-milenij.png" style={{ maxHeight: '96px' }} />}
            </Grid>
          </GridContainer>
        </Box>

        <Typography component="div" variant="h1" className={classes.titleRoot}>
          {variant === 'standard' ? 'Login' : 'Milenij Hotel Mobile'}
        </Typography>
        <form>
          <Box mb={2}>
            <TextField
              label={variant === 'standard' ? <IntlMessages id="appModule.email" /> : 'Korisničko ime'}
              fullWidth
              onChange={event => setEmail(event.target.value)}
              defaultValue={email}
              margin="normal"
              variant="outlined"
              className={classes.textFieldRoot}
            />
          </Box>
          <Box mb={2}>
            <TextField
              type="password"
              label={variant === 'standard' ? <IntlMessages id="appModule.password" /> : 'Lozinka'}
              fullWidth
              onChange={event => setPassword(event.target.value)}
              defaultValue={password}
              margin="normal"
              variant="outlined"
              className={classes.textFieldRoot}
            />
          </Box>
          {variant === 'milenij' ? (
            <Box mb={2}>
              <TextField
                label={variant === 'standard' ? <IntlMessages id="appModule.hotelCode" /> : 'Šifra hotela'}
                fullWidth
                onChange={event => setHotelCode(event.target.value)}
                defaultValue={hotelCode}
                margin="normal"
                variant="outlined"
                className={classes.textFieldRoot}
              />
            </Box>
          ) : null}
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={5}>
            {variant == 'standard' && (
              <FormControlLabel
                className={classes.formcontrolLabelRoot}
                control={<Checkbox name="checkedA" />}
                label="Remember me"
              />
            )}
            <Box component="p" fontSize={{ xs: 12, sm: 16 }}>
              {variant === 'standard' ? (
                <NavLink to="/forgot-password">
                  <IntlMessages id="appModule.forgotPassword" />
                </NavLink>
              ) : null}
            </Box>
          </Box>

          <Box display="flex" alignItems="center" justifyContent="space-between" mb={5}>
            {variant === 'milenij' && (
              <Button onClick={onSubmit} variant="contained" color="primary" fullWidth>
                Prijava
              </Button>
            )}

            {variant === 'standard' && (
              <Button onClick={onSubmit} variant="contained" color="primary" fullWidth>
                <IntlMessages id="appModule.signIn" />
              </Button>
            )}

            <Box component="p" fontSize={{ xs: 12, sm: 16 }}>
              {variant === 'standard3' ? (
                <NavLink to="/signup">
                  <IntlMessages id="signIn.signUp" />
                </NavLink>
              ) : null}
            </Box>
          </Box>
          {variant === 'milenij' ? (
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={5}>
              <Button onClick={onSubmit2} variant="contained" color="primary" fullWidth>
                Istražite demo
              </Button>
            </Box>
          ) : null}
        </form>

        {dispatch(AuhMethods[method].getSocialMediaIcons())}
        {((variant === 'standard' && hostName === 'app.mikos.io') ||
          (variant === 'standard' && hostName === 'app.forotel.com')) && (
          <small>Copyright© {date.getFullYear()} forotel</small>
        )}
        {variant === 'standard' &&
          hostName !== 'app.mikos.io' &&
          variant === 'standard' &&
          hostName !== 'app.forotel.com' && <small>Copyright© {date.getFullYear()} Alpha Software Ltd.</small>}
        {variant != 'standard' && <small>Powered by WebBookingPro</small>}

        <ContentLoader />
      </Box>
    </AuthWrapper>
  );
};

export default SignIn;
